import { ICourseOption } from "@into-discovery/browsewebshared";
import React from "react";
import PathwayOptionRow from "./pathway-option-row";

type Props = {
  courseOptions: ICourseOption[];
  brandId: string;
  brandName: string;
  brandCountry: string;
  brandPrimaryColor: string;
  themeColor: string;
  invertedTheme: boolean;
  handleApplyClick: (toggleModal: boolean, courseName: string, courseApplyURL: string) => void;
};

export default function PathwayOptions({
  courseOptions,
  brandId,
  brandName,
  brandCountry,
  brandPrimaryColor,
  themeColor,
  invertedTheme,
  handleApplyClick
}: Props) {
  if (!courseOptions?.length) {
    return null;
  }
  const courseOptionList = courseOptions.map((courseOption) => (
    <PathwayOptionRow
      key={`${courseOption.name} ${courseOption.slug}`}
      brandName={brandName}
      courseOption={courseOption}
      brandId={brandId}
      brandCountry={brandCountry}
      disableCourseLink={courseOption?.disableCourseLink}
      brandPrimaryColor={brandPrimaryColor}
      themeColor={themeColor}
      invertedTheme={invertedTheme}
      handleApplyClick={handleApplyClick}
    />
  ));

  return <>{courseOptionList}</>;
}
